
const CalendarIcon = (props) => (
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="0.900146"
      y="1"
      width="49"
      height="49"
      rx="24.5"
      fill="#FDFD1F"
      stroke="#FDFD1F"
    />
    <g clip-path="url(#clip0_1151_9019)">
      <path
        d="M35.1242 16.2653C34.7578 15.9168 34.1633 15.9168 33.7968 16.2653L15.6815 33.4749C15.3148 33.8231 15.3148 34.3874 15.6815 34.7357C15.8648 34.9099 16.1051 34.9971 16.3453 34.9971C16.5854 34.9971 16.8258 34.9099 17.0089 34.7357L35.1242 17.5261C35.4909 17.1779 35.4909 16.6135 35.1242 16.2653Z"
        fill="black"
      />
      <path
        d="M19.8589 16.0098C17.4005 16.0098 15.4001 17.9102 15.4001 20.2457C15.4001 22.5812 17.4005 24.4815 19.8589 24.4815C22.3175 24.4815 24.3176 22.5811 24.3176 20.2456C24.3176 17.9101 22.3173 16.0098 19.8589 16.0098ZM19.8589 22.6979C18.4355 22.6979 17.2775 21.5977 17.2775 20.2456C17.2775 18.8935 18.4356 17.7932 19.8589 17.7932C21.2823 17.7932 22.4403 18.8935 22.4403 20.2456C22.4403 21.5977 21.2823 22.6979 19.8589 22.6979Z"
        fill="black"
      />
      <path
        d="M30.9414 26.5244C28.483 26.5244 26.4827 28.4247 26.4827 30.7602C26.4827 33.0957 28.483 34.996 30.9414 34.996C33.3999 34.996 35.4002 33.0959 35.4002 30.7602C35.4002 28.4246 33.3999 26.5244 30.9414 26.5244ZM30.9414 33.2124C29.518 33.2124 28.36 32.1122 28.36 30.7601C28.36 29.408 29.5181 28.3077 30.9414 28.3077C32.3647 28.3077 33.5228 29.408 33.5228 30.7601C33.5228 32.1122 32.3649 33.2124 30.9414 33.2124Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1151_9019">
        <rect
          width="20"
          height="19"
          fill="black"
          transform="translate(15.4001 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default CalendarIcon;
